// Vendors
import "./vendor/autotrack";
import "jquery";
import "moment";
import "bootstrap-sass";
import "../scss/innri.scss";
import Cookies from "js-cookie";
// Global requirements
import "./custom/csrf_safe";
import "bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import swiper from "swiper/bundle";
import "swiper/swiper-bundle.css";
window.Swiper = swiper;
import "cropperjs/dist/cropper.css";
import Cropper from "cropperjs";
window.Cropper = Cropper;
import Noty from "noty";
window.Noty = Noty;
const csrftoken = Cookies.get("csrftoken");
// Imports all images
require.context("../images/", false, /\.(png|jpg|jpeg|svg)$/);
